/**
 * The only dot in the widget. Present means "happening right now", absent means
 * "not now". No legend required — and no tenant colour coding, since tenants are
 * filtered from the dashboard topbar, not from here.
 */
export function LiveDot({ tone = "accent" }: { tone?: "accent" | "error" }) {
  const color = tone === "error" ? "bg-status-error" : "bg-brand-cyan";
  return (
    <span className="relative flex h-2 w-2 shrink-0" aria-hidden>
      <span className={`absolute inline-flex h-full w-full animate-ping motion-reduce:animate-none rounded-full opacity-60 ${color}`} />
      <span className={`relative inline-flex h-2 w-2 rounded-full ${color}`} />
    </span>
  );
}
